import { render, staticRenderFns } from "./SelfEmployed.vue?vue&type=template&id=09b455c2"
import script from "./SelfEmployed.vue?vue&type=script&lang=js"
export * from "./SelfEmployed.vue?vue&type=script&lang=js"
import style0 from "./SelfEmployed.vue?vue&type=style&index=0&id=09b455c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports